import { useMemo } from "react";

import { useAuth } from "@/lib/config/auth-provider";
import { PASTE_QUESTIONNAIRE_ID } from "@/pages/HomeLabPage/studyTypeLookup";

/**
 * Study types closed for this org (global OR org kill-switch).
 * `paste_questionnaire` and Quick Study `generic` alias to `explore`.
 */
const STUDY_TYPE_ALIASES: Record<string, string> = {
  generic: "explore",
  [PASTE_QUESTIONNAIRE_ID]: "explore",
};

export function canonicalizeClosedStudyTypeId(
  value: string | null | undefined,
): string | null {
  if (!value) {
    return null;
  }
  return STUDY_TYPE_ALIASES[value] ?? value;
}

export function useClosedStudyTypes(): ReadonlySet<string> {
  const { user } = useAuth();
  return useMemo(() => {
    const ids = user?.closedStudyTypes ?? [];
    return new Set(ids);
  }, [user?.closedStudyTypes]);
}

export function isStudyTypeClosed(
  closed: ReadonlySet<string>,
  studyTypeId: string | null | undefined,
): boolean {
  const canonical = canonicalizeClosedStudyTypeId(studyTypeId);
  if (!canonical) {
    return false;
  }
  return closed.has(canonical);
}
